<div
  class="card-grid"
  [ngStyle]="{ 'grid-template-columns': 'repeat(' + (columns || 1) + ', 1fr)' }"
  role="list"
>
  <button
    class="card"
    *ngFor="let opt of options"
    type="button"
    role="listitem"
    [attr.aria-pressed]="isSelected(opt)"
    [class.selected]="isSelected(opt)"
    [disabled]="disabled"
    (click)="select(opt)"
  >
    <div class="card-icon">
      <mat-icon class="material-symbols-outline">
        {{ opt.icon || 'warning' }}
      </mat-icon>
    </div>
    <div class="card-body">
      <div class="card-title">{{ opt.title | translate }}</div>
      <div class="card-desc" *ngIf="opt.description">{{ opt.description | translate }}</div>
    </div>
  </button>
</div>
